import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useT } from "../../shared/i18n";
import { useDemoMode } from "./useDemoMode";

/**
 * The slim, non-blocking read-only notice (ADR-0045). It sits directly under
 * the offline banner and never covers content or captures a tap.
 *
 * @returns the banner, or null outside demo mode.
 */
export function DemoBanner() {
  const t = useT();
  const demoMode = useDemoMode();
  if (!demoMode) return null;

  return (
    <Box
      role="status"
      data-testid="demo-banner"
      sx={{
        flexShrink: 0,
        px: 2,
        py: 0.5,
        bgcolor: "info.main",
        color: "info.contrastText",
      }}
    >
      <Typography variant="body2" align="center">
        {t("demoBanner")}
      </Typography>
    </Box>
  );
}
